import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Input } from '@1trading/react/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@1trading/react/components/ui/select';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import type { AmlQuestionnaireEmploymentDetails } from '@/features/onboarding/aml-questionnaire/schema';
import { AML_MONETARY_ANSWERS } from '@/services/api/profile/aml';

const AmlQuestionnaireFieldsetEmploymentDetailsLegend = () => {
  const { t } = useTranslation();

  return (
    <PageHeading asChild>
      <legend>
        <PageHeadingTitle>{t('AMLQuestionnaire.employmentDetails.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('AMLQuestionnaire.employmentDetails.description')}</PageHeadingDescription>
      </legend>
    </PageHeading>
  );
};
AmlQuestionnaireFieldsetEmploymentDetailsLegend.displayName = 'AmlQuestionnaireFieldsetEmploymentDetailsLegend';

const AmlQuestionnaireFieldsetEmploymentDetails = () => {
  const form = useFormContext<AmlQuestionnaireEmploymentDetails>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        name="occupation"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('AMLQuestionnaire.occupation.title')}</FormLabel>
            <FormControl>
              <Input {...field} placeholder={t('AMLQuestionnaire.pleaseSpecify')} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="annualNetIncome"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('AMLQuestionnaire.annualNetIncome.title')}</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('AMLQuestionnaire.pleaseSpecify')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {AML_MONETARY_ANSWERS.map((answer) => (
                  <SelectItem key={answer} value={answer}>
                    {t(`AMLQuestionnaire.annualNetIncome.options.${answer}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
AmlQuestionnaireFieldsetEmploymentDetails.displayName = 'AmlQuestionnaireFieldsetEmploymentDetails';

export { AmlQuestionnaireFieldsetEmploymentDetails, AmlQuestionnaireFieldsetEmploymentDetailsLegend };
